import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    role: "list",
    class: "grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 overflow-hidden mb-2",
    style: { "padding": "10px !important" }
};
const _hoisted_2 = { class: "flex-1 flex flex-col p-8" };
const _hoisted_3 = {
    key: 0,
    class: "mt-6 text-gray-900 text-sm font-medium font-bold"
};
const _hoisted_4 = {
    key: 1,
    class: "mt-6 text-gray-900 text-sm font-medium"
};
const _hoisted_5 = { class: "mt-1 flex-grow flex flex-col justify-between" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("dt", { class: "sr-only" }, "Title", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("dt", { class: "sr-only" }, "Role", -1);
const _hoisted_8 = { class: "mt-3" };
const _hoisted_9 = { class: "px-2 py-1 text-xs font-medium" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_11 = { class: "px-2 py-1 text-xs font-medium inline-flex items-center justify-center gap-1" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = { class: "px-2 py-1 text-xs font-medium break-words min-w-0 block" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_15 = { class: "px-2 py-1 text-xs font-medium break-words min-w-0 block" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_17 = { class: "px-2 py-1 text-xs font-medium" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { class: "-mt-px flex divide-x divide-gray-200" };
const _hoisted_21 = { class: "w-0 flex-1 flex" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("span", {
    class: "ml-3",
    style: { "cursor": "pointer" }
}, "View Document", -1);
import { employeeDisplayName, managerDisplayName, } from '@/helpers/document-card-people';
import { DocumentTextIcon, EyeIcon } from '@heroicons/vue/outline';
import { inject } from 'vue';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'document-cards',
    props: {
        allDocuments: {},
        userprofile: {}
    },
    setup(__props) {
        const router = useRouter();
        const formatDate = inject('formatDate');
        const props = __props;
        const routes = {
            STARTER: 'view-starter',
            LEAVER: 'view-leaver',
            AMEND: 'view-amend',
            OFFER: 'view-offer',
        };
        const navigateToDocument = async (id, docOwner) => {
            // find document
            const document = props.allDocuments.find((atr) => atr.docId === id);
            if (document && document.currentStageName === 'starter.notifyRecruitment') {
                router.push({ path: `/recruitment-team/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRecruitmentUpdated') {
                router.push({ path: `/recruitment-update/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRoleAdvertised') {
                router.push({ path: `/advert-raised/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyCVsCollected') {
                router.push({ path: `/ready-for-selection/${id}/${docOwner}` });
            }
            else if (document &&
                (document.currentStageName === 'starter.notifyCandidateSelected' ||
                    document.currentStageName === 'starter.complete')) {
                router.push({ path: `/selection-complete/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyMakeOffer') {
                router.push({ path: `/offer-hr/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyPrepOffer') {
                router.push({ path: `/confirm/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyTermsHaveChanged') {
                router.push({ path: `/amend-terms/${id}/${docOwner}` });
            }
            else if (document && document.currentStageName === 'offer.notifyH2RAdmin') {
                router.push({ path: `/assign-admin-owner/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyOfferSent') {
                router.push({ path: `/sap-confirmation/${id}/${docOwner}` });
            }
            else if (document) {
                router.push({ path: `/${routes[document.docType]}/${id}/${docOwner}` });
            }
            else {
                console.error(`No route found for document with ID ${id}`);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.allDocuments, (document) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: document.shortId,
                        class: "col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(DocumentTextIcon), {
                                class: _normalizeClass(["w-24 h-24 flex-shrink-0 mx-auto", {
                                        'text-gray-400': document.docType === 'STARTER',
                                        'text-orange-400': document.docType === 'AMEND',
                                        'text-red-400': document.docType === 'LEAVER',
                                        'text-green-500': document.docType === 'OFFER',
                                    }])
                            }, null, 8, ["class"]),
                            _createTextVNode(),
                            (document.shortId)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(document.shortId), 1))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_4, "N/A")),
                            _createTextVNode(),
                            _createElementVNode("dl", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("dd", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, "Created:\n              " + _toDisplayString(_unref(formatDate)
                                        ? _unref(formatDate)(document.createdDate, "DD/MM/YYYY")
                                        : document.createdDate), 1),
                                    _createTextVNode(),
                                    _hoisted_10,
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_11, "\n              Doc Type: " + _toDisplayString(document.docType), 1),
                                    _createTextVNode(),
                                    _hoisted_12,
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_13, "Employee: " + _toDisplayString(_unref(employeeDisplayName)(document)), 1),
                                    _createTextVNode(),
                                    _hoisted_14,
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_15, "Manager: " + _toDisplayString(_unref(managerDisplayName)(document)), 1),
                                    _createTextVNode(),
                                    _hoisted_16,
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_17, [
                                        _createTextVNode("Assignee:\n              "),
                                        (document.currentAssignee)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(document.currentAssigneeEmail), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_19, "N/A"))
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", {
                                        class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500",
                                        onClick: ($event) => (navigateToDocument(document.docId, document.requestedBy))
                                    }, [
                                        _createVNode(_unref(EyeIcon), {
                                            class: "w-5 h-5 text-gray-400",
                                            "aria-hidden": "true"
                                        }),
                                        _createTextVNode(),
                                        _hoisted_23
                                    ], 8, _hoisted_22)
                                ])
                            ])
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
